/* eslint-disable react/jsx-filename-extension */
import React, { useEffect, useState } from 'react';
import ReactGA from 'react-ga4';
import { useLocation } from 'react-router-dom';
import Router from '../../catalog/Router';
import Header from './Header';
import Footer from './Footer';
import { Navigation } from '../../catalog/Nav';
import MobileMenu from './MobileMenu';
import SupernovaPopup from '../../catalog/SupernovaPopup';

import 'sass';
import './cssfiles/css/animate.css';
import './cssfiles/css/admin.css';
import './cssfiles/css/normalize.css';
import './cssfiles/css/bootstrap.css';
import './cssfiles/css/bootstrap-theme.css';
// import './cssfiles/css/font-awesome.css';
import './cssfiles/css/grid.css';
import './cssfiles/css/login.css';
import './cssfiles/css/style.effects.css';
import './cssfiles/css/style.scss.css';
import './cssfiles/css/style-build.css';
// import './cssfiles/shop-online.css/bootstrap.css';
// import './cssfiles/shop-online.css/custom-style.css';
// import './cssfiles/shop-online.css/new-home-page-style.css';
// import './cssfiles/shop-online.css/search-page-style.css';
// import './cssfiles/shop-online.css/slick-theme.css';
// import './cssfiles/shop-online.css/slick.css';
// import './cssfiles/shop-online.css/style.css';
// import './cssfiles/shop-online.css/app.css';
// import './cssfiles/style.css';
import './App.css';

export default function App(props) {
  const title = 'Genesee | Laboratory & Office Seating';
  const catalog = 'partner';
  const partner = 'genesee';
  const logoURL = 'https://ecomseating.s3.amazonaws.com/images/other/genesee-logo.png';
  const buildAChair = 'bfr6SbGSE';
  const extraAttributes = {
    trackId: 'G-QFJZTXQJ55',
  };

  ReactGA.initialize(extraAttributes.trackId);
  useEffect(() => {
    ReactGA.send({ hitType: 'pageview', page: window.location.pathname });
  }, []);

  document.title = title;
  document.partner = partner;
  document.catalog = catalog;
  document.buildAChair = buildAChair;

  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div>
      <link href="https://fonts.googleapis.com/css?family=Glyphicons_Halflings" rel="stylesheet" />
      <SupernovaPopup
        host="https://seating.geneseesci.com"
        backgroundColor="white"
        textColor="#007aff"
      />
      <header>
        <Header onMenuOpen={(e) => setMenuOpen(true)} />
        {
        menuOpen
        && <MobileMenu onMenuClose={(e) => setMenuOpen(false)} />
        }
      </header>
      <div className="center-container">
        <div className="filter-bound-top main-nav">
          <Navigation partner={partner} url={logoURL} />
        </div>
        <Router
          partner={partner}
          catalog={catalog}
          orderButtonType="rfq"
          logoURL={logoURL}
          extraAttributes={extraAttributes}
        />
      </div>
      <footer className="filter-bound-bottom">
        <Footer />
      </footer>
    </div>
  );
}
